angular.module('editingCenterServiceModule')
    .service('editingCenterIMApiService', ecIMApiService);

ecIMApiService.$inject = ['trsHttpService'];


/**
 * [ecIMApiService IM模块API请求服务]
 *
 * @param   {[type]}  trsHttpService  [trsHttpService description]
 *
 * @return  {[type]}                  [return description]
 */
function ecIMApiService(trsHttpService) {
    var request = trsHttpService.httpServer;
    var getUrl = function (key) {
        return {
            'mlf': trsHttpService.getWCMRootUrl
        }[key];
    };

    var extend = angular.extend;
    return {
        send: sendMessage,
        getGroupList: getGroupList,
        getUserList: getUserList,
        getlastChatList: getlastChatList
    };

    /**
     * [sendMessage 发送消息]
     *
     * @param   {[type]}  params  [params description]
     *
     * @return  {[type]}          [return description]
     */
    function sendMessage(params) {
        let oprType = params.oprType;
        let objId = params.objId;
        delete params.oprType;
        delete params.objId;
        let requestParams = extend({
            serviceid: 'zmy_im',
            methodname: 'sendMessage',
            messageSendDTO: JSON.stringify(params),
            oprType: oprType,
            objId: objId
        }, {});
        return request(getUrl('mlf')(), requestParams, 'post');
    }

    /**
     * [getGroupList 获取工作室列表]
     *
     * @param   {[type]}  params  [params description]
     *
     * @return  {[type]}          [return description]
     */
    function getGroupList(params) {
        let requestParams = extend({
            serviceid: 'zmy_studio',
            methodname: 'queryStudios'
        }, params);
        return request(getUrl('mlf')(), requestParams, 'get');
    }

    /**
     * [getUserList 获取同事列表]
     *
     * @param   {[type]}  params  [params description]
     *
     * @return  {[type]}          [return description]
     */
    function getUserList(params) {
        let requestParams = extend({
            serviceid: 'zmy_studio',
            methodname: 'queryColleagues'
        }, params);
        return request(getUrl('mlf')(), requestParams, 'get');
    }

    /**
     * [getGroupList 获取最近聊天列表]
     *
     * @param   {[type]}  params  [params description]
     *
     * @return  {[type]}          [return description]
     */
    function getlastChatList(params) {
        let requestParams = extend({
            platform: 'TENCENT_IM'
        }, params);
        return request('/wcm/im_forward.action', requestParams, 'post', false, {
            serviceid: 'account',
            methodname: 'queryRecentlyChat'
        });
    }
}
